export default {
    'AUTH.FORGET_PASSWORD.TITLE': 'Forget password',
    'AUTH.FORGET_PASSWORD.ASIDE': 'Please fill your email, we will send you a link to create a new password.',
    'AUTH.FORGET_PASSWORD.BUTTON': 'Send me the link',
    'AUTH.FORGET_PASSWORD.NEW.ONE': 'Your new password',
    'AUTH.FORGET_PASSWORD.NEW.TWO': 'Confirm your new password',
};
